The unique identifier of the event. This corresponds to the `Event.id` field in the GraphQL schema.
